import { useEffect, useRef, useState } from "react";
import { Box, Button, List, ListItem, ListItemButton, ListItemText, Typography, Paper, IconButton } from "@mui/material";
import AddScenarioButton from "./utilities/AddScenarioDialog";
import { useParams } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';


export default function ScenarioLoader({ selectedScenario, setSelectedScenario, onChangeScenario }) {

    const { id } = useParams();

    const [scenarios, setScenarios] = useState([]);
    const [scenarioName, setScenarioName] = useState('');

    const changeScenarioRef = useRef(null);

    const fetchScenarios = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/container/${id}`);
            if (!res.ok) throw new Error("Błąd pobierania scenariuszy");
            const data = await res.json();
            setScenarios(data?.stations);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchScenarioById = async (id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/${id}`);
            if (!res.ok) throw new Error("Błąd pobierania scenariusza");
            const data = await res.json();
            setSelectedScenario(data);
            console.log("Pobrany scenariusz:", data);
        } catch (err) {
            console.error(err);
        }
    };

    const addNewScenario = async (id, containerSize) => {

        const scenarioGUID = crypto.randomUUID();

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(
                    {
                        "containerId": Number(id),
                        // "existingSource": scenarioName || `Nowy scenariusz ${Date.now()}`,
                        "stationName": scenarioName || `Stacja ${dayjs().format('DD.MM HH:mm')}`,
                        "GUID": scenarioGUID,
                        "dimensionX": containerSize.width || 10,
                        "dimensionY": 0,
                        "dimensionZ": containerSize.height || 10,
                        "entities": [
                            {
                                "name": "exe_graphic_cc_logos_8",
                                "GUID": crypto.randomUUID(),
                                "posX": 1,
                                "posY": 0,
                                "posZ": -2,
                                "rotX": 0,
                                "rotY": 180,
                                "rotZ": 0
                            },
                            {
                                "name": "exe_graphic_cc_logos_12",
                                "GUID": crypto.randomUUID(),
                                "posX": 1,
                                "posY": 0,
                                "posZ": -2,
                                "rotX": 0,
                                "rotY": 180,
                                "rotZ": 0
                            }
                        ]
                    }

                ),
            });
            if (!res.ok) throw new Error("Błąd dodawania scenariusza");
            const data = await res.json();
            setScenarios(prev => [...prev, data]);
            setSelectedScenario(data);
            // console.log("Pobrany scenariusz:", data);
            fetchScenarios();
        } catch (err) {
            console.error(err);
        }
    };


    const deleteScenarioById = async (id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/${id}`, {
                method: "DELETE",
            });
            if (!res.ok) throw new Error("Błąd usuwania scenariusza");
            setScenarios((prev) => prev.filter((s) => s.id !== id));
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchScenarios();
    }, [id]);



    const changeScenario = (direction) => {
        if (!selectedScenario || !scenarios.length) return;

        const index = scenarios.findIndex(s => s.id === selectedScenario.id);
        if (index === -1) return;

        let nextIndex = index + direction;

        if (nextIndex < 0) nextIndex = scenarios.length - 1;
        if (nextIndex >= scenarios.length) nextIndex = 0;

        setSelectedScenario(scenarios[nextIndex]);
    };

    useEffect(() => {
        changeScenarioRef.current = changeScenario;
        if (onChangeScenario) onChangeScenario(changeScenarioRef);
    }, [changeScenario, onChangeScenario]);



    return (
        <Paper sx={{ p: 2, width: 300, position: "absolute", top: 80, right: 10 }}>
            <Typography variant="h6">Stacje</Typography>
            <List dense sx={{ maxHeight: 300, overflowY: "auto", overflowX: "hidden" }}>
                {scenarios.map((s) => (
                    <ListItem key={s.id} disablePadding sx={{
                        mr: 1,
                        backgroundColor: s.id === selectedScenario?.id ? '#6cc6d9' : 'transparent',
                        borderRadius: .5
                    }}
                        secondaryAction={
                            <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => deleteScenarioById(s.id)}
                                color="error"
                            >
                                <CloseIcon />
                            </IconButton>
                        }
                    >
                        <ListItemButton onClick={() => fetchScenarioById(s.id)}>
                            {/* <ListItemText primary={`${s.existingSource} (ID:${s.id})`} /> */}
                            <ListItemText primary={`${s.stationName !== null ? s.stationName : 'Stacja'} (ID:${s.id})`} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            {/* {selectedScenario && (
                <Box mt={2}>
                    <Typography variant="subtitle1">Wybrany scenariusz:</Typography>
                    <pre style={{ whiteSpace: "pre-wrap" }}>
                        {JSON.stringify(selectedScenario, null, 2)}
                    </pre>
                </Box>
            )} */}

            {/* <Button variant="contained" sx={{ mt: 2 }} onClick={fetchScenarios}>
                Odśwież listę
            </Button> */}

            {/* <Button variant="contained" sx={{ mt: 2 }} onClick={addNewScenario}>
                Dodaj scenariusz
            </Button> */}
            <AddScenarioButton addNewScenario={addNewScenario} scenarioName={scenarioName} setScenarioName={setScenarioName} />
        </Paper>
    );
}
